"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const buildCallableStartPlayingAudio_1 = require("./buildCallableStartPlayingAudio");
const buildCallablePausePlayingAudio = (args) => async ({ callbacks, executeProcesses, }) => {
    const state = await args.getState();
    if (state === buildCallableStartPlayingAudio_1.SoundPlayingState.PLAYING) {
        await args.pauseAudio();
        if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.onNotPlayingAudio) {
            executeProcesses(undefined, callbacks.onNotPlayingAudio);
        }
    }
};
exports.default = buildCallablePausePlayingAudio;
